import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { AccountService } from '../../service/data/account.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { IsMobileDevice } from '../../../core/helper/mobile';
import { ProfileService } from '../../service/data/profile.service';

@Component({
    selector: 'app-help-page',
    templateUrl: './help-page.component.html',
    styleUrls: ['./help-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HelpPageComponent implements OnInit {
  form: FormGroup;
  isMobile: boolean;
  private readonly _spinnerDelay: number = 1500;
  private readonly _buttonDisableDelay: number = 5000;

  constructor(
    private readonly _nativeWindow: NativeWindowService,
    private readonly _dataService: AccountService,
    private readonly _navigation: NavigationService,
    private readonly _profileService: ProfileService,
    fb: FormBuilder,
    fcf: FormControlExFactory
  ) {
    this.form = fb.group({
      message: fcf.createMandatory('SUPPORT.MESSAGE', ''),
    });
  }

  dhNews() {
    this._nativeWindow.openTab('https://sites.google.com/view/dinhyresvard/nyheter');
  }

  dhUserManual() {
    this._nativeWindow.openTab('https://sites.google.com/view/dinhyresvard');
  }

  dhQAndA() {
    this._nativeWindow.openTab('https://support.hogia.se/DinHyresvard-FAQ.search');
  }

  dhElearning() {
    this._nativeWindow.openTab('https://support.hogia.se/24719.guide?nodeID=0');
  }

  ngOnInit(): void {
    this.isSendingEmail = false;
    this.isSendButtonDisabled = false;
    this.isMobile = IsMobileDevice();

    this._profileService.get().subscribe(profile => {
      this.licenseNumber = profile.hogiaCustomerNumber?.toString() || '';
    });
  }

  isSendingEmail: boolean;
  isSendButtonDisabled: boolean;
  licenseNumber: string = '';

  sendMail() {
    const messageControl = this.form.controls['message'];
    if (!messageControl.value?.trim() || this.form.invalid) {
      messageControl.setErrors({ ...messageControl.errors, required: true });
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    this.isSendingEmail = true;
    this.isSendButtonDisabled = true;
    this.form.value.page = this._navigation.url;
    const formValue = this.form.value;
    this._dataService.support(formValue).subscribe({
      next: () => {
        this.form.controls['message'].setValue('');
      },
      error: () => {
        this._sendEmailButtonProcessing();
      },
      complete: () => {
        this._sendEmailButtonProcessing();
      },
    });
  }

  private _sendEmailButtonProcessing() {
    setTimeout(() => {
      this.isSendingEmail = false;
    }, this._spinnerDelay);
    setTimeout(() => {
      this.isSendButtonDisabled = false;
    }, this._buttonDisableDelay);
  }
}
